<!--  -->
<template>
  <div class="US">
    <mb-header theme='dark'></mb-header>

    <div class="header">
      <router-link to="/m_index" class="content_btn">
        <img src="../assets/logo.png" alt class="logo">
      </router-link>
    </div>
    <div class="main">
      <ul class="main_ul">
        <li>
          <h3 class="main_h3 active">样册索取</h3>
          <div class="get_book">
            <img src="../assets/cont4.33a5d964.png" alt>
            <p>我们提供的样册中除了包含尺寸、形状、精度等级、齿距、硬度、是否研磨、容许扭矩等规格参数外，还附有齿轮技术参考书，在客户设计选型时发挥重要作用。</p>
          </div>
          <div class="get_btn" v-show="!showExplame" @click="showExplame = true">
            <span>样册索取</span>
          </div>
        </li>
        <li class="get_expleam" v-show="showExplame">
          <input type="text" placeholder="* 您的邮箱地址" v-model="user_Email">
          <input type="text" placeholder="* 贵公司全称" v-model="user_company">
          <input type="text" placeholder="* 您的姓名" v-model="user_name">
          <input type="text" placeholder="* 您的电话或手机号码" v-model="user_phone">
          <div class="select">
            <select name="public-choice" v-model="provinceSelected" class="select_1">
              <option value disabled selected style="display:none; color: #ccc">* 省/自治区/直辖市</option>
              <option
                :value="item.value"
                v-for="(item) in provinceData"
                :key="item.key"
              >{{item.value}}</option>
            </select>
            <select name="public-choice" v-model="citySelected" class="select_2">
              <option value disabled selected style="display:none;">* 市/县/区</option>
              <option
                :value="item.value"
                v-for="(item,index) in cityData"
                :key="index"
              >{{item.value}}</option>
            </select>
          </div>
          <input type="text" placeholder="详细街道和门牌号" v-model="user_address">
          <div class="get_btn">
            <span @click="confirm">确认发送</span>
          </div>
        </li>
        <li v-show="!showExplame">
          <h3 class="main_h3">通讯地址</h3>
          <div class="address">
            <div class="right">
              <div class="com_name">
                <!-- <img src="../../assets/cont1.png" alt class="cn"> -->
                <p class="cn_p">
                  <span>上海米仑机械设备有限公司</span>
                  <span>SHANGHAI MILLION MACHINERY CO.,LTD.</span>
                </p>
              </div>
              <div class="mail">
                <p>
                  <span class="key">地址：</span>
                  <span class="val">{{addressItem.address}}</span>
                </p>
                <p>
                  <span class="key">邮箱：</span>
                  <span class="val">{{addressItem.e_mail}}</span>
                </p>
                <p>
                  <span class="key">电话：</span>
                  <span class="val">{{addressItem.contact_number}}</span>
                </p>
                <p>
                  <span class="key">传真：</span>
                  <span class="val">{{addressItem.fax}}</span>
                </p>
                <!-- <p>邮箱： {{addressItem.e_mail}}</p>
                <p>电话： {{addressItem.contact_number}}</p>
                <p>传真： {{addressItem.fax}}</p> -->
              </div>
            </div>
          </div>
          <div class="get_btn">
            <router-link to="/m_advantage" class="content_btn">合作优势</router-link>
          </div>
        </li>
      </ul>
    </div>
    <mb-fotter></mb-fotter>
    <back-top></back-top>
  </div>
</template>

<script>
import request from "../server/request.js";
import city from "../utils/city.js";
import mbFotter from "../components/moblie-fotter.vue";
import mbHeader from "../components/moblie-header.vue";
import backTop from "../components/back-top.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    mbFotter,
    mbHeader,
    backTop
  },

  data() {
    //这里存放数据
    return {
      addressItem: {},
      provinceData: [],
      cityData: [],
      provinceSelected: "",
      citySelected: "",
      user_name: "",
      user_company: "",
      user_phone: "",
      user_Email: "",
      user_address: "",
      showExplame: false
    };
  },

  //监听属性 类似于data概念
  computed: {},

  //监控data中的数据变化
  watch: {
    provinceSelected: function(val, oldval) {
      if (val != oldval) {
        const currentItem = this.provinceData.filter(
          item => item.value === val
        )[0];
        if (this.provinceSelected) {
          const value = `${currentItem.key.substring(0, 2)}0000`;
          for (const key in city[value]) {
            if (city[value].hasOwnProperty.call(city[value], key)) {
              const element = city[value][key];
              this.cityData.push({
                key,
                value: element
              });
            }
          }
        }
      }
    }
  },

  //方法集合
  methods: {
    confirm() {
      if (
        !this.user_phone ||
        !this.user_Email ||
        !this.provinceSelected ||
        !this.citySelected ||
        !this.user_name ||
        !this.user_company
      ) {
        alert("请完善相关信息");
      } else {
        const formData = {
          user_email: this.user_Email,
          user_name: this.user_name,
          user_phone: this.user_phone,
          user_address: this.user_address,
          user_company: this.user_company,
          user_province: this.provinceSelected,
          user_city: this.citySelected
        };
        request.postUserManage(formData, res => {
          if (res && res.errcode === 0) {
            this.showExplame = false;
            alert(
              "我们收到了您填写的信息, 稍后我们将会发送邮件给您，请注意查收～"
            );
          }
        });
      }
    },
    loadData() {
      request.getAddress(res => {
        if (res && res.errcode === 0) {
          this.addressItem = res.data[0];
        }
      });
    }
  },

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (city) {
      for (const key in city["86"]) {
        if (city["86"].hasOwnProperty.call(city["86"], key)) {
          const element = city["86"][key];
          this.provinceData.push({
            key,
            value: element
          });
        }
      }
    }
    this.loadData();
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
};
</script>
<style lang='less' scoped>
.US {
  background: #fff9dd;
  min-height: 100vh;
  .header {
    width: 100%;
    .logo {
      margin: 0.3rem 0 0 0.3rem;
      width: 35%;
    }
  }
  .main {
    // margin-top: 1rem;
    width: 80%;
    margin: 0 auto;
    padding-bottom: 0.3rem;
    .main_ul {
      .get_expleam {
        position: relative;
        font-size: 0.28rem;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        p {
          width: 100%;
          text-align: left;
          color: #2583c9;
          margin-left: 20%;
        }
        input {
          width: 100%;
          height: 0.84rem;
          margin-bottom: 0.2rem;
          padding-left: 10px;
          border-radius: 5px;
          border: 2px solid #0583c9;
          color: #999;
          // border: none;
        }
        .select {
          display: flex;
          width: 100%;
          height: 0.84rem;
          border-radius: 5px;
          margin-bottom: 0.2rem;
          .select_1 {
            width: 60%;
            border: 2px solid #0583c9;
            background: #fff;
            color: #999;
            margin-right: 2%;
            cursor: pointer;
            border-radius: 5px;
          }
          .select_2 {
            width: 40%;
            border: 2px solid #0583c9;
            cursor: pointer;
            color: #999;
            border-radius: 5px;
            background: #fff;
          }
        }
      }
      li {
        display: flex;
        flex-direction: column;
        margin-bottom: 0.6rem;
        .main_h3 {
          padding-top: 0.38rem;
          font-size: 0.38rem;
          font-weight: 800;
          margin: 0;
        }
        .address {
          display: flex;
          .right {
            .com_name {
              display: flex;
              .cn_p {
                display: flex;
                flex-direction: column;
                color: #054183;
                font-size: 0.24rem;
                span {
                  margin-top: 0.2rem;
                  color: #054183;
                  &:first-child {
                    font-weight: 900;
                    font-size: 0.4rem;
                  }
                }
              }
            }
            .mail {
              position: relative;
              z-index: 10;
              color: #333;
              font-size: 0.3rem;
              p {
                margin: 0;
                margin-bottom: 0.3rem;
                display: flex;
                align-items: flex-start;
                .key {
                  display: block;
                  width: 16%;
                }
                .val {
                  display: block;
                  line-height: 2;
                  margin-top: -6px;
                  width: 84%;
                }
              }
            }
          }
        }
        .get_book {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          img {
            width: 1.5rem;
            // height: 3rem;
            // margin-left: 35%;
            margin-right: 0.38rem;
          }
          p {
            // width: 6rem;
            line-height: 1.8;
            font-size: 0.28rem;
            font-family: SourceHanSansSC;
            font-weight: 400;
            line-height: 1.8;
          }
        }
        .get_btn {
          text-align: center;
          width: 40%;
          height: 0.84rem;
          background: #0583c9;
          line-height: 0.84rem;
          color: #fff;
          border-radius: 6px;
          margin: 0.1rem auto 0;
          font-size: 0.36rem;
          font-weight: normal;
          a {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>